'use client'

import { RadioGroup, styled } from '@mui/joy'

const UIRadioGroupRoot = styled(RadioGroup)({
	fontSize: 0,
	'.MuiRadio-root': {
		margin: 0,
	},
})

export default UIRadioGroupRoot
